import {AppThunk} from '../index';
import {molodayaArcticaActions, molodayaArcticaSlice} from '../../reducers/molodayaArctica';
import {getApiRoute} from '../../../shared/pipes';
import {apiUrls} from '../../../shared/constants/urls';
import {addNotification} from '../snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {storage, StorageKeys} from '../../../shared/storage';
import {IndexItemValidationError} from '../../../shared/models/serverValidationError';
import {MolodayaArcticaItem, WithdrawSource} from '../../../shared/models/api/molodayaArticaResponsePayload';
import {getDobroruData} from '../dobroru';
import {HttpStatusCode} from '../../../shared/httpWrapper/httpStatusCode';

export const getMolodayaArcticaData = (): AppThunk => {
  return async (dispatch, getState) => {
    const token: string | null = await storage.getItem(StorageKeys.token);
    if (getState().molodayaArctica.dataLoading || !token) return;

    try {
      dispatch(molodayaArcticaActions.setDataLoading(true));

      const response = await fetch(getApiRoute(apiUrls.molodayaArcticaTransactions), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const error: IndexItemValidationError = await response.json();
        const errorText = error?.[0]?.message || 'Не удалось получить данные из Молодой арктики';
        throw new Error(errorText);
      }
      const data: MolodayaArcticaItem[] = await response.json();
      dispatch(
        molodayaArcticaSlice.actions.setData(
          data.filter(
            (x) =>
              (x.withdrawSource === WithdrawSource.Arctica && x.products.length) ||
              x.withdrawSource === WithdrawSource.Ekg,
          ),
        ),
      );
    } catch (e: any) {
      dispatch(
        addNotification({
          message: e?.message,
          type: SnackbarNotificationType.Error,
        }),
      );
      dispatch(molodayaArcticaActions.setData(null));
    } finally {
      dispatch(molodayaArcticaActions.setDataLoading(false));
    }
  };
};

export const postTransferVolunteerScore = (): AppThunk => {
  return async (dispatch, getState) => {
    const token: string | null = await storage.getItem(StorageKeys.token);
    if (getState().molodayaArctica.dataLoading || !token) return;

    try {
      dispatch(molodayaArcticaActions.setDataLoading(true));

      const response = await fetch(getApiRoute(apiUrls.postTransferVolunteerScore), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'POST',
      });

      if (response.status === HttpStatusCode.notFound) throw new Error(response.statusText);

      if (!response.ok) {
        const error: IndexItemValidationError = await response.json();
        const errorText = error?.[0]?.message || 'Не удалось получить данные из Молодой арктики';
        throw new Error(errorText);
      }
      dispatch(getDobroruData());
    } catch (e: any) {
      dispatch(
        addNotification({
          message: e?.message,
          type: SnackbarNotificationType.Error,
        }),
      );
    } finally {
      dispatch(molodayaArcticaActions.setDataLoading(false));
    }
  };
};
